import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import { clubInfo } from "@/lib/mbti";
import { Users } from "lucide-react";

/* Taxa de presença de cada clube nas reuniões já realizadas da edição. */
export default function ClubAttendanceRates({ club }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/league/attendance-rates").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const clubs = (data?.clubs || []).filter((c) => !club || c.club === club);
  if (!data || !data.meetings || !clubs.length) return null;

  return (
    <div className={`kw-card kw-fade-up ${club ? "p-4" : "p-6"}`} data-testid="club-attendance-rates">
      <div className="flex items-center gap-2 mb-5">
        <Users className="w-4 h-4 text-[#E50000]" />
        <div className="kw-overline flex-1">Presença nas reuniões{club ? "" : " · por clube"}</div>
        <span className="text-[10px] uppercase tracking-widest text-[#737373]">{data.meetings} reuniões</span>
      </div>
      <div className={club ? "max-w-md" : "grid grid-cols-2 lg:grid-cols-4 gap-4"}>
        {clubs.map((c) => {
          const color = clubInfo(c.club)?.color || "#E50000";
          return (
            <div key={c.club} data-testid={`attendance-rate-${c.club}`}>
              <div className="flex items-baseline justify-between">
                <span className="text-xs uppercase tracking-widest font-bold" style={{ color }}>{c.club}</span>
                <span className="font-display text-2xl font-black">{c.rate == null ? "—" : `${c.rate}%`}</span>
              </div>
              <div className="h-1.5 bg-[#1A1A1A] mt-2 overflow-hidden">
                <div className="h-full transition-[width] duration-700" style={{ width: `${c.rate || 0}%`, background: color }} />
              </div>
              <div className="text-[10px] text-[#737373] mt-1">{c.present} de {c.total} presenças</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
